module.exports = __webpack_public_path__ + "static/media/tech-video-5.1cea840a.png";